export default __webpack_public_path__ + "static/realWorldImg1-e25270e7ce3a38d2b4a4249aaac38f76.png";